import { render } from "./BindingHospLogin.vue?vue&type=template&id=a36fc0b6&scoped=true"
import script from "./BindingHospLogin.vue?vue&type=script&lang=js"
export * from "./BindingHospLogin.vue?vue&type=script&lang=js"

import "./assets/index.css?vue&type=style&index=0&id=a36fc0b6&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a36fc0b6"]])

export default __exports__